export default __webpack_public_path__ + "static/media/mod07.04297c18.svg";